import { render, staticRenderFns } from "./InviteAcceptView.vue?vue&type=template&id=01a5d306&scoped=true&"
import script from "./InviteAcceptView.vue?vue&type=script&lang=ts&"
export * from "./InviteAcceptView.vue?vue&type=script&lang=ts&"
import style0 from "./InviteAcceptView.vue?vue&type=style&index=0&id=01a5d306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5d306",
  null
  
)

export default component.exports